module.exports = __webpack_public_path__ + "static/media/X5new.da60923c.jpg";